import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Experts, ExpertsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ExpertsDataService {

  private uri: string = `${environment.apiUrl}experts`;
  private cacheKey: string = 'experts.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getExpert(id: number): Observable<Experts|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getExperts(parameters: {[param: string]: string | string[]}): Observable<ExpertsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addExpert(data: Experts): Observable<Experts|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addExperts(data: Experts[]): Observable<Experts[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateExpert(data: Experts): Observable<Experts|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateExperts(data: Experts[]): Observable<Experts[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchExpert(data: Experts): Observable<Experts|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchExperts(data: Experts[]): Observable<Experts[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteExpert(data: Experts): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteExperts(data: Experts[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((expert) => {
      ids.push(expert.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
